import type { SmartSchedulingSlotsPayload } from "./smart-scheduling.types";

import { smartSchedulingEndpoint } from "../endpoints";

export async function validateSmartSchedulingSlots(
  userToken: string,
  payload: SmartSchedulingSlotsPayload,
) {
  const response = await fetch(
    `${smartSchedulingEndpoint}/${userToken}/validate`,
    {
      method: "POST",
      body: JSON.stringify({ ...payload }),
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    return response.json();
  }

  return response.json();
}
